import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const SectionTemplatePage_SaveSectionTemplatePreview_Mutation = graphql(`
  mutation SectionTemplatePage_SaveSectionTemplatePreview(
    $printableId: Id!
    $versionData: VersionDataInput
  ) {
    saveSectionTemplatePreview(
      printableId: $printableId
      versionData: $versionData
    ) {
      ...PrinterContextProvider_PdfPrint_Fragment
    }
  }
`);

export type SaveSectionTemplatePreview_Result = ResultOf<
  typeof SectionTemplatePage_SaveSectionTemplatePreview_Mutation
>;

export const useSavePreviewMutation = () =>
  useGraphQLMutation(SectionTemplatePage_SaveSectionTemplatePreview_Mutation);
